var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TableSimpleBlock',{attrs:{"title":"Resumen incidencias por proveedor","items":_vm.issueSupplierReportData,"fields":_vm.fields,"isLoading":_vm.isIssueSupplierReportLoading}})}
var staticRenderFns = []

export { render, staticRenderFns }